import React, { useCallback } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { usePostHog } from 'posthog-js/react';
import { REDESIGN_COLORS } from '../../styles/colors';
import { useTier } from '../../context/TierContext';

/**
 * FeedCapCTA - Free user's "see all listings" upsell, rendered after the
 * 10-listing display cap in the unified feed.
 *
 * @param {Object} props
 * @param {number} props.totalCount - Total number of listings the user would have access to with Pro
 */
const FeedCapCTA = ({ totalCount }) => {
  const { triggerUpgradeModal } = useTier();
  const posthog = usePostHog();

  const handlePress = useCallback(() => {
    if (posthog) {
      posthog.capture('feed_listings_cap_hit', { total_count: totalCount });
    }
    triggerUpgradeModal?.({ source: 'cap_feed_listings' });
  }, [posthog, totalCount, triggerUpgradeModal]);

  return (
    <View style={styles.container}>
      <Pressable
        onPress={handlePress}
        style={styles.button}
        accessibilityRole="button"
        accessibilityLabel={`See all ${totalCount} listings with Pro`}
      >
        <View style={styles.badge}>
          <Text style={styles.badgeText}>Pro</Text>
        </View>
        <Text style={styles.buttonText}>See all {totalCount} listings with Pro</Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 48,
    alignItems: 'center',
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(59, 130, 246, 0.3)',
    backgroundColor: 'rgba(59, 130, 246, 0.08)',
  },
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    backgroundColor: '#3b82f6',
    borderRadius: 4,
  },
  badgeText: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 11,
    color: '#ffffff',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  buttonText: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 14,
    color: REDESIGN_COLORS.textPrimary,
  },
});

export default FeedCapCTA;
